import { Input } from '../../atomsLegacy/Input/Input';
import {
  IconButton,
  IconButtonProps,
} from '../../atomsLegacy/buttons/IconButton/IconButton';
import { IconInput as StyledIconInput } from './IconInput.styles';
import * as React from 'react';

export type IconInputProps = {
  inputProps: React.ComponentPropsWithoutRef<typeof Input> & {
    testId?: string;
  };
  buttonProps: IconButtonProps;
};

/**
 * Allowing the user to input one line of text
 * and have a button for the user to perform another action.
 * E.G. Edit input or save changes made.
 */
export const IconInput: React.FC<IconInputProps> = (props: IconInputProps) => {
  return (
    <StyledIconInput>
      <Input data-testid={props.inputProps.testId} {...props.inputProps} />
      <IconButton
        data-testid={props.buttonProps.testId}
        {...props.buttonProps}
        size="large"
      />
    </StyledIconInput>
  );
};

export default IconInput;
